import React from 'react';

class VisionMission extends React.Component {
    render() {
        return (
            <div className="section-full mobile-page-padding p-t80 p-b80 bg-gray overflow-hide">
                <div className="container">
                    <div className="section-head text-center wow fadeInUp" data-wow-duration="1s">
                        <div className="sx-separator-outer separator-center">
                            <div className="sx-separator bg-white">
                                <h3 className="sep-line-one">Our Vision</h3>
                            </div>
                        </div>
                        {/* <p style={{ color: '#666666', fontSize: '15px', maxWidth: '650px', margin: '15px auto 40px auto', textAlign: 'center' }}>
                            Setting the benchmark for premium architectural cladding with uncompromised quality and long-lasting durability across Coimbatore and Tamil Nadu.
                        </p> */}
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10 col-md-12 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
                            <div 
                                className="bg-white bdr-gray-light bdr-solid bdr-1"
                                style={{
                                    borderRadius: '20px',
                                    padding: '50px 40px',
                                    boxShadow: '0 12px 35px rgba(0,0,0,0.06)',
                                    borderTop: '5px solid #f03a02',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    textAlign: 'center'
                                }}
                            >
                                {/* Decorative Soft Radial Background Glow */}
                                <div style={{
                                    position: 'absolute',
                                    top: '-80px',
                                    right: '-80px',
                                    width: '220px',
                                    height: '220px',
                                    borderRadius: '50%',
                                    background: 'radial-gradient(circle, rgba(240, 58, 2, 0.08) 0%, rgba(240, 58, 2, 0) 70%)',
                                    pointerEvents: 'none'
                                }} />

                                {/* Main Vision Title */}
                                <h3 style={{
                                    fontSize: '26px',
                                    fontWeight: '800',
                                    marginBottom: '18px',
                                    color: '#111111',
                                    lineHeight: '1.4'
                                }}>
                                    Pioneering Architectural Excellence with <span style={{ color: '#f03a02' }}>Uncompromised Quality</span> &amp; <span style={{ color: '#f03a02' }}>Long-Lasting</span> Durability
                                </h3>

                                {/* Main Vision Content Paragraph */}
                                <p style={{
                                    fontSize: '16.5px',
                                    lineHeight: '1.85',
                                    color: '#555555',
                                    maxWidth: '850px',
                                    margin: '0 auto 35px auto',
                                    textAlign: 'center'
                                }}>
                                    Our vision is to be the premier benchmark of excellence in architectural ACP Front Elevation, Facade Glazing, and Toughened Glass solutions. We are committed to delivering <strong>unmatched Quality</strong> and <strong>long-lasting durability</strong> that withstand extreme weather elements while transforming modern building skylines.
                                </p>

                                {/* PROMINENT HIGHLIGHT CARDS (Quality & Long-Lasting) */}
                                <div className="row justify-content-center" style={{ gap: '20px 0' }}>
                                    {/* Quality Highlight */}
                                    <div className="col-md-6 col-sm-12">
                                        <div style={{
                                            backgroundColor: '#fbfbfb',
                                            border: '1px solid #f0f0f0',
                                            borderLeft: '4px solid #f03a02',
                                            borderRadius: '12px',
                                            padding: '22px 24px',
                                            textAlign: 'left',
                                            height: '100%',
                                            boxShadow: '0 4px 15px rgba(0,0,0,0.03)',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-4px)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(240, 58, 2, 0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.03)';
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '10px' }}>
                                                <div style={{
                                                    width: '42px',
                                                    height: '42px',
                                                    borderRadius: '10px',
                                                    backgroundColor: 'rgba(240, 58, 2, 0.1)',
                                                    color: '#f03a02',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '20px',
                                                    flexShrink: 0
                                                }}>
                                                    <i className="fa fa-certificate" />
                                                </div>
                                                <div>
                                                    <span style={{ fontSize: '11px', fontWeight: '800', color: '#f03a02', letterSpacing: '1px', textTransform: 'uppercase', display: 'block' }}>
                                                        CORE PROMISE
                                                    </span>
                                                    <h5 style={{ margin: 0, fontWeight: '800', fontSize: '17px', color: '#111111' }}>
                                                        Uncompromised Quality
                                                    </h5>
                                                </div>
                                            </div>
                                            <p style={{ margin: 0, fontSize: '14px', color: '#666666', lineHeight: '1.6' }}>
                                                100% certified ACP sheets, facade glazing, toughened safety glass, and genuine flawless precision.
                                            </p>
                                        </div>
                                    </div>

                                    {/* Long-Lasting Highlight */}
                                    <div className="col-md-6 col-sm-12">
                                        <div style={{
                                            backgroundColor: '#fbfbfb',
                                            border: '1px solid #f0f0f0',
                                            borderLeft: '4px solid #f03a02',
                                            borderRadius: '12px',
                                            padding: '22px 24px',
                                            textAlign: 'left',
                                            height: '100%',
                                            boxShadow: '0 4px 15px rgba(0,0,0,0.03)',
                                            transition: 'transform 0.3s ease, box-shadow 0.3s ease'
                                        }}
                                        onMouseEnter={(e) => {
                                            e.currentTarget.style.transform = 'translateY(-4px)';
                                            e.currentTarget.style.boxShadow = '0 8px 25px rgba(240, 58, 2, 0.1)';
                                        }}
                                        onMouseLeave={(e) => {
                                            e.currentTarget.style.transform = 'translateY(0)';
                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(0,0,0,0.03)';
                                        }}>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '14px', marginBottom: '10px' }}>
                                                <div style={{
                                                    width: '42px',
                                                    height: '42px',
                                                    borderRadius: '10px',
                                                    backgroundColor: 'rgba(240, 58, 2, 0.1)',
                                                    color: '#f03a02',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    fontSize: '20px',
                                                    flexShrink: 0
                                                }}>
                                                    <i className="fa fa-shield" />
                                                </div>
                                                <div>
                                                    <span style={{ fontSize: '11px', fontWeight: '800', color: '#f03a02', letterSpacing: '1px', textTransform: 'uppercase', display: 'block' }}>
                                                        ENGINEERED TO LAST
                                                    </span>
                                                    <h5 style={{ margin: 0, fontWeight: '800', fontSize: '17px', color: '#111111' }}>
                                                        Long-Lasting Durability
                                                    </h5>
                                                </div>
                                            </div>
                                            <p style={{ margin: 0, fontSize: '14px', color: '#666666', lineHeight: '1.6' }}>
                                                Zero-leakage weather sealing and heavy-duty structural fitting designed to withstand harsh weather for decades.
                                            </p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default VisionMission;
